import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { AlerteDto } from "../../../../dto/GenApi.iNotPaie.Dto/AlerteDto";
import $ from "jquery";
import { NiveauAlerte } from "../../../../dto/GenApi.iNotPaie.Dto/NiveauAlerte";
import { alertesActions, isClickableAlerte } from "../../../../Helper/alertesHelper";

@Component
export default class ModalCardAlert extends Vue {
    @Prop({ required: true })
	public alertes!: AlerteDto[];

    @Prop({ required: true })
	public isUtilisateurPst!: boolean;

    @Prop({ required: true })
    public isAdmin!: boolean;

    @Prop({ required: true })
    public isAdminPst!: boolean;

    @Prop({ required: true })
    public isPayeur!: boolean;

    public niveauAlerte = NiveauAlerte;

	public getClass(type: NiveauAlerte): string {
    	let classFa = "";

    	switch (type) {
    		case NiveauAlerte.Critique:
    			classFa = "critical";
    			break;
    		case NiveauAlerte.Majeur:
    			classFa = "red";
    			break;
    		case NiveauAlerte.Intermediaire:
    			classFa = "orange";
    			break;
    		case NiveauAlerte.Mineur:
    			classFa = "yellow";
    			break;
    	}

    	return classFa;
	}

	public clickEvent(alerte: AlerteDto): void {
        alertesActions(alerte, this.isAdmin, this.isAdminPst, this.isPayeur, this.isUtilisateurPst) ? $("#modalCardAlert").modal("hide") : null;
    }

    public isClickable(alerte: AlerteDto): boolean {
        return isClickableAlerte(alerte);
    }
}



// WEBPACK FOOTER //
// ./src/components/home/modals/modalCardAlert/modalCardAlert.ts